// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\BillingInvoiceUrlResponse

export type BillingInvoiceUrlApiResponse = {
	url: string | null;
};

export type BillingInvoiceUrl = {
	url: string | null;
};

export function hydrateBillingInvoiceUrl(data: BillingInvoiceUrlApiResponse): BillingInvoiceUrl {
	return { ...data };
}